import { DASHBOARD_RESOURCES, DASHBOARD_SCOPES, PAGE_NAMES } from 'constant';
import { EMPTY_ARRAY } from 'commons-ui';
import { DEFAULT } from '../utils/constant';

export const makeActionList = (params: any) => {
	const { hasPermission, appName } = params;

	return {
		bulkActions: EMPTY_ARRAY,
		rowActions: [
			{
				name: 'Update Util %',
				id: 'updateUtilPer',
				isEnabled: () => {
					return hasPermission({
						entity: DASHBOARD_RESOURCES.cashbackUtil,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil]?.editCashbackSegments,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			},
			{
				name: 'Delete',
				id: 'deletePriority',
				isEnabled: (rowData: any) => {
					const { segmentName } = rowData;
					if (segmentName === DEFAULT) {
						return false;
					}
					return hasPermission({
						entity: DASHBOARD_RESOURCES.cashbackUtil,
						action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil]?.deleteCashbackSegments,
						appName,
						configPageName: PAGE_NAMES.dashboard
					});
				}
			}
		],
		addAction: {
			name: 'Add',
			id: 'add',
			isEnabled: () => {
				return hasPermission({
					entity: DASHBOARD_RESOURCES.cashbackUtil,
					action: DASHBOARD_SCOPES[DASHBOARD_RESOURCES.cashbackUtil]?.getCashbackUtils,
					appName,
					configPageName: PAGE_NAMES.dashboard
				});
			}
		}
	};
};

export default {
	makeActionList
};
